import ProductConfirmationConnectModal from './ProductConfirmationConnectModal';

export default ProductConfirmationConnectModal;
